import { useEffect } from 'react'
import { apiGetAppliedSkinConfig } from '@/api/common'
import useGlobalThemeStore from '@/store/globalTheme'

const useTheme = () => {
    const { theme, setTheme } = useGlobalThemeStore()
    const token = {
        colorPrimary: theme.colorPrimary,
        colorLink: theme.colorPrimary,
        colorText: '#031F47',
        borderRadius: 2,
        colorBorder: '#F0F0F0'
    }

    useEffect(() => {
        if (window.microApp) {
            return
        }
        apiGetAppliedSkinConfig({ domainUrl: window.location.origin }).then((result: any) => {
            if (!result) {
                setTheme({
                    colorPrimary: '#0087e1',
                    logoUrl: '',
                    loginPageImageUrl: '',
                    systemName: 'iKG',
                    loginPageBgcolor: '',
                })
                return
            }
            setTheme({
                colorPrimary: result.mainColor,
                logoUrl: result.logoUrl,
                loginPageImageUrl: result.loginPageImageUrl,
                systemName: result.productName,
                loginPageBgcolor: result.loginPageBgcolor,
            })
        })
        return () => {
            setTheme({
                colorPrimary: '',
                logoUrl: '',
                loginPageImageUrl: '',
                systemName: '',
                loginPageBgcolor: '',
            })
        }
    }, [setTheme])

    useEffect(() => {
        const dataListener = (data: any) => {
            if (data?.theme?.colorPrimary) {
                setTheme({
                    colorPrimary: data.theme.colorPrimary,
                })
            }
        }
        if (window.microApp) {
            window.microApp.addDataListener(dataListener, true)
        }
        return () => {
            if (window.microApp) {
                window.microApp.removeDataListener(dataListener)
            }
        }
    }, [setTheme])

    return { token, theme }
}

export default useTheme
